<!--活动报名信息分享查看-->
<template>
    <div class="home-entry-container">
        <div class="entry-head-container">
            <div class="entry-top-left1">
                <div class="entry-wel-logo cursor" @click="jumpPageNotAuth('/jzedu/wel')">
                    <img class="cursor" style="width: 54px;height: 38px;" src="../../assets/lyjy.png" alt="精准教研">

                </div>
            </div>
            <div class="entry-top-left2">
                <div class="entry-top-left21">
                    <div style="margin-right: 8px;">专题活动</div>
                    <div class="entry-status-info-bm">报名教师及资料</div>
                </div>
                <div class="entry-top-left22">
                    <span>{{info.activityName}}</span>
                </div>
            </div>
            <div class="entry-top-right">
                <div class="event-right-ntn">
                    <div class="event-bm-btn" @click="viewActivityInfo">活动详情</div>
                </div>
            </div>
        </div>
        <!-- 报名列表 -->
        <div class="entry-content-container" v-show="this.showMode==='page'">
            <el-table header-cell-class-name="bgf2" show-overflow-tooltip
                      height="calc(100vh - 160px)"
                      :data="dataList"
                      class="custom-table"
                      highlight-current-row>
                <el-table-column type="index"  fixed="left" align="center" label="序号" width="60" />
                <el-table-column align="center" width="140px" label="报名时间"  prop="">
                    <template #default="scope">
                        <div>
                            {{ timestampToTime(scope.row.submitTime) }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column align="center" width="100px" label="教师姓名"  prop="trueName"/>
                <el-table-column align="center" width="140px" label="手机号码"  prop="userId"/>
                <el-table-column  align="center" width="120px" label="学段学科">
                    <template #default="scope">
                        <el-text>
                            {{scope.row.periodName?scope.row.periodName:'--'}}•{{scope.row.subjectName?scope.row.subjectName:'--'}}
                        </el-text>
                    </template>
                </el-table-column>
                <el-table-column  align="center" width="160px" label="所属单位" prop="orgName">
                </el-table-column>
                <el-table-column  align="center" width="80px" label="最高学历" prop="qualificationName">
                </el-table-column>
                <el-table-column  align="center" width="120px"  label="技术职称" prop="rankLevelName">
                </el-table-column>
                <el-table-column width="360px" align="center" label="课例名称" prop="lessonName">
                </el-table-column>
                <el-table-column fixed="right" label="操作" align="center" width="100">
                    <template #default="scope">
                        <el-button type="primary" size="small" @click="queryUserSignInfo(scope.row)">查看</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="page-container">
                <pageTag :background="true"
                         :pageSizes="[10, 20, 30]"
                         :total="total"
                         v-model:page.sync="queryParams.pageNum"
                         v-model:limit.sync="queryParams.pageSize"
                         @pagination="getPageRaceSign" />
            </div>
        </div>
        <!-- 报名详情 -->
        <div class="entry-content-container2" v-show="this.showMode==='info'">
            <div class="event-topic-sign-container">
                <div class="event-topic-sign-form">
                    <div class="kl-container">
                        <div class="kl-l cursor" @click="backPage">
                            <svg t="1766638364292" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6637" width="28" height="28"><path d="M512 512m-465.454545 0a465.454545 465.454545 0 1 0 930.90909 0 465.454545 465.454545 0 1 0-930.90909 0Z" fill="#e6e6e6" p-id="6638"></path><path d="M512 1024C229.236364 1024 0 794.763636 0 512S229.236364 0 512 0s512 229.236364 512 512-229.236364 512-512 512zM443.904 515.258182l205.637818-205.637818a58.181818 58.181818 0 1 0-82.292363-82.292364l-246.830546 246.830545a58.181818 58.181818 0 0 0 2.606546 84.712728l244.31709 244.363636a58.181818 58.181818 0 1 0 82.292364-82.292364l-205.730909-205.730909z" fill="#ff7f2e" p-id="6639" data-spm-anchor-id="a313x.search_index.0.i1.3a373a81dKtAXk" class="selected"></path></svg>
                        </div>
                        <div class="kl-r">{{signForm.lessonName}}</div>
                        <div class="kl-l"></div>
                    </div>
                    <el-form ref="signForm" :model="signForm" label-position="top">
                        <div class="event-topic-sign-title">基本信息</div>
                        <el-row>
                            <el-col :span="11">
                                <el-form-item label="教师姓名" prop="trueName">
                                    <el-input disabled v-model="signForm.trueName" placeholder="请输入教师姓名"  />
                                </el-form-item>
                            </el-col>
                            <el-col :span="1"></el-col>
                            <el-col :span="11">
                                <el-form-item  prop="username">
                                    <template #label>
                                        教师手机号码
                                    </template>
                                    <el-input disabled v-model="signForm.username" placeholder="请输入手机号码"/>
                                </el-form-item>
                            </el-col>


                        </el-row>
                        <el-row>
                            <el-col :span="11">
                                <el-form-item label="课例名称" prop="lessonName" >
                                    <el-input disabled v-model="signForm.lessonName" placeholder="请输入课例名称" />
                                </el-form-item>
                            </el-col>
                            <el-col :span="1"></el-col>
                            <el-col :span="11">
                                <el-form-item label="所属学校" prop="orgName">
                                    <el-input disabled v-model="signForm.orgName" placeholder="请输入所属学校"  />
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="11">
                                <el-form-item label="任教学段" prop="periodKey">
                                    <el-select disabled style="width: 100%;" v-model="signForm.periodKey"
                                               placeholder="请选择任教学段">
                                        <el-option v-for="item in periodList" :key="item.dictKey" :label="item.dictValue"
                                                   :value="item.dictKey" />
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="1"></el-col>
                            <el-col :span="11">
                                <el-form-item label="任教学科" prop="subjectKey">
                                    <el-select disabled style="width: 100%;" v-model="signForm.subjectKey"
                                               placeholder="请选择任教学科">
                                        <el-option v-for="item in subjectList" :key="item.dictKey" :label="item.dictValue"
                                                   :value="item.dictKey" />
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="11">
                                <el-form-item label="最高学历" prop="qualificationKey">
                                    <el-select disabled style="width: 100%;" v-model="signForm.qualificationKey"
                                               placeholder="请选择最高学历">
                                        <el-option v-for="item in qualificationList" :key="item.dictKey" :label="item.dictValue"
                                                   :value="item.dictKey" />
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="1"></el-col>
                            <el-col :span="11">
                                <el-form-item label="技术职称" prop="rankLevel">
                                    <el-select disabled style="width: 100%;" v-model="signForm.rankLevel"
                                               placeholder="请选择技术职称">
                                        <el-option v-for="item in rankList" :key="item.dictKey" :label="item.dictValue"
                                                   :value="item.dictKey" />
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <div class="event-topic-sign-title">相关附件</div>
                        <div class="event-topic-file-container">
                            <div class="event-topic-file-item-title">
                                教案、教学设计
                            </div>
                            <div class="entry-file-list">
                                <div class="entry-file-item" v-for="item in this.signInfo.jxsjFileList" :key="item">
                                    <div class="entry-file-title" @click="downloadFile(item)">{{item.fileName}}</div>
                                    <div class="entry-file-view">
                                        <el-image @click="handleFIleStatus(item.status)" class="entry-file-icon" style="margin-top: 2px"
                                                  :src="require('@/assets/file/file_view_color.png')"
                                                  :preview-src-list="gainFileImgList(item.imgUrl,item.pages,item.fileType,item.fileUrl)">
                                        </el-image>
                                    </div>
                                    <div class="entry-file-view" @click="downloadFile(item)">
                                        <svg t="1742438760961" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20003" width="24" height="22"><path d="M867.705263 485.519719v359.298246h-718.596491v-359.298246h-71.859649v395.22807c0 19.761404 16.168421 35.929825 35.929824 35.929825h790.456141c19.761404 0 35.929825-16.168421 35.929824-35.929825v-395.22807h-71.859649z" p-id="20004" fill="#ff7f2e"></path><path d="M508.407018 665.168842c8.982456 0 17.964912-3.592982 25.150877-10.778947l215.578947-215.578948-50.301754-50.301754-154.498246 154.498246v-452.71579h-71.859649v452.71579l-154.498246-154.498246-50.301754 50.301754 215.578947 215.578948c7.185965 7.185965 16.168421 10.778947 25.150878 10.778947z" p-id="20005" fill="#ff7f2e"></path></svg>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="event-topic-file-container">
                            <div class="event-topic-file-item-title">
                                教学课件
                            </div>
                            <div class="entry-file-list">
                                <div class="entry-file-item" v-for="item in this.signInfo.jxkjFileList" :key="item">
                                    <div class="entry-file-title" @click="downloadFile(item)">{{item.fileName}}</div>
                                    <div class="entry-file-view">
                                        <el-image @click="handleFIleStatus(item.status)" class="entry-file-icon" style="margin-top: 2px"
                                                  :src="require('@/assets/file/file_view_color.png')"
                                                  :preview-src-list="gainFileImgList(item.imgUrl,item.pages,item.fileType,item.fileUrl)">
                                        </el-image>
                                    </div>
                                    <div class="entry-file-view" @click="downloadFile(item)">
                                        <svg t="1742438760961" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20003" width="24" height="22"><path d="M867.705263 485.519719v359.298246h-718.596491v-359.298246h-71.859649v395.22807c0 19.761404 16.168421 35.929825 35.929824 35.929825h790.456141c19.761404 0 35.929825-16.168421 35.929824-35.929825v-395.22807h-71.859649z" p-id="20004" fill="#ff7f2e"></path><path d="M508.407018 665.168842c8.982456 0 17.964912-3.592982 25.150877-10.778947l215.578947-215.578948-50.301754-50.301754-154.498246 154.498246v-452.71579h-71.859649v452.71579l-154.498246-154.498246-50.301754 50.301754 215.578947 215.578948c7.185965 7.185965 16.168421 10.778947 25.150878 10.778947z" p-id="20005" fill="#ff7f2e"></path></svg>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="event-topic-file-container">
                            <div class="event-topic-file-item-title">
                                课堂实录
                            </div>
                            <div class="entry-file-list">
                                <div class="entry-file-item" v-for="item in this.signInfo.ktslFileList" :key="item">
                                    <div class="entry-file-title" @click="downloadFile(item)">{{item.fileName}}</div>
                                    <div class="entry-file-view">
                                        <el-image class="entry-file-icon" style="margin-top: 2px"
                                                  :src="require('@/assets/file/file_bf.png')"
                                                  @click="openVideo(item.fileUrl)">
                                        </el-image>
                                    </div>
                                    <div class="entry-file-view" @click="downloadFile(item)">
                                        <svg t="1742438760961" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20003" width="24" height="22"><path d="M867.705263 485.519719v359.298246h-718.596491v-359.298246h-71.859649v395.22807c0 19.761404 16.168421 35.929825 35.929824 35.929825h790.456141c19.761404 0 35.929825-16.168421 35.929824-35.929825v-395.22807h-71.859649z" p-id="20004" fill="#ff7f2e"></path><path d="M508.407018 665.168842c8.982456 0 17.964912-3.592982 25.150877-10.778947l215.578947-215.578948-50.301754-50.301754-154.498246 154.498246v-452.71579h-71.859649v452.71579l-154.498246-154.498246-50.301754 50.301754 215.578947 215.578948c7.185965 7.185965 16.168421 10.778947 25.150878 10.778947z" p-id="20005" fill="#ff7f2e"></path></svg>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="event-topic-file-container">
                            <div class="event-topic-file-item-title">
                                微课、课例视频
                            </div>
                            <div class="entry-file-list">
                                <div class="entry-file-item" v-for="item in this.signInfo.wkspFileList" :key="item">
                                    <div class="entry-file-title" @click="downloadFile(item)">{{item.fileName}}</div>
                                    <div class="entry-file-view">
                                        <el-image class="entry-file-icon" style="margin-top: 2px"
                                                  :src="require('@/assets/file/file_bf.png')"
                                                  @click="openVideo(item.fileUrl)">
                                        </el-image>
                                    </div>
                                    <div class="entry-file-view" @click="downloadFile(item)">
                                        <svg t="1742438760961" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20003" width="24" height="22"><path d="M867.705263 485.519719v359.298246h-718.596491v-359.298246h-71.859649v395.22807c0 19.761404 16.168421 35.929825 35.929824 35.929825h790.456141c19.761404 0 35.929825-16.168421 35.929824-35.929825v-395.22807h-71.859649z" p-id="20004" fill="#ff7f2e"></path><path d="M508.407018 665.168842c8.982456 0 17.964912-3.592982 25.150877-10.778947l215.578947-215.578948-50.301754-50.301754-154.498246 154.498246v-452.71579h-71.859649v452.71579l-154.498246-154.498246-50.301754 50.301754 215.578947 215.578948c7.185965 7.185965 16.168421 10.778947 25.150878 10.778947z" p-id="20005" fill="#ff7f2e"></path></svg>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="event-topic-file-container">
                            <div class="event-topic-file-item-title">
                                教学资源包
                            </div>
                            <div class="entry-file-list">
                                <div class="entry-file-item" v-for="item in this.signInfo.jxzyFileList" :key="item">
                                    <div class="entry-file-title" @click="downloadFile(item)">{{item.fileName}}</div>
                                    <div class="entry-file-view">
                                        <el-image @click="handleFIleStatus(item.status)" class="entry-file-icon" style="margin-top: 2px"
                                                  :src="require('@/assets/file/file_view_color.png')"
                                                  :preview-src-list="gainFileImgList(item.imgUrl,item.pages,item.fileType,item.fileUrl)">
                                        </el-image>
                                    </div>
                                    <div class="entry-file-view" @click="downloadFile(item)">
                                        <svg t="1742438760961" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20003" width="24" height="22"><path d="M867.705263 485.519719v359.298246h-718.596491v-359.298246h-71.859649v395.22807c0 19.761404 16.168421 35.929825 35.929824 35.929825h790.456141c19.761404 0 35.929825-16.168421 35.929824-35.929825v-395.22807h-71.859649z" p-id="20004" fill="#ff7f2e"></path><path d="M508.407018 665.168842c8.982456 0 17.964912-3.592982 25.150877-10.778947l215.578947-215.578948-50.301754-50.301754-154.498246 154.498246v-452.71579h-71.859649v452.71579l-154.498246-154.498246-50.301754 50.301754 215.578947 215.578948c7.185965 7.185965 16.168421 10.778947 25.150878 10.778947z" p-id="20005" fill="#ff7f2e"></path></svg>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-form>
                </div>
            </div>
        </div>
    </div>
    <!--音视频播放-->
    <el-dialog v-model="isShowVideo" width="76%" top="50px" @close="closeIframe">
        <iframe id="open-video" style="width: 100%;height:calc(100vh - 200px)" :src="videoSrc"
                frameborder="0"></iframe>
    </el-dialog>

</template>
<script>
import {timestampToTime} from "@/utils/date";
import {downloadFile} from "@/api/adminservice/public";
import {serviceUrl} from "@/utils/global";
import {queryDict} from "@/api/admin/activityLink";
import {activityInfo, infoActivitySignUp,pageActivitySign} from "@/api/admin/eduActivity";
import pageTag from "@/components/Pagination/page.vue";
export default {
    components: {pageTag},
    name: "homeEntry",
    data() {
        return {
            timestampToTime,
            serviceUrl,
            showMode:'page',
            periodList: [],
            subjectList: [],
            qualificationList:[],
            rankList:[],
            infoId:"",
            info:{},
            queryParams: {
                raceId: '',
                status: '1',
                signType:2,
                pageNum: 1,
                pageSize: 10,
            },
            total:0,
            dataList:[],
            signForm:{},
            signInfo:{},
            videoSrc:"",
            isShowVideo:false,
        }
    },
    computed: {},
    watch: {},
    created() {
        if (this.$route.query.aid){
            this.infoId = this.$route.query.aid;
            this.queryParams.raceId = this.infoId;
            this.getQueryDict();
            this.queryInfo()
            this.getPageRaceSign(null);
        }
    },
    mounted() {},
    methods: {
        getQueryDict() {
            /*档案学段学科*/
            queryDict({ code: 'archive_xd_xk' }).then(res => {
                this.periodList = res.data.data;
            })
            /*最高学历*/
            queryDict({ code: 'qualification' }).then(res => {
                this.qualificationList = res.data.data;
            })
            /*技术职称*/
            queryDict({ code: 'technical_title' }).then(res => {
                this.rankList = res.data.data;
            })
        },
        queryInfo(){
            activityInfo({ activityId: this.infoId}).then(res => {
                if (res.data.code===1){
                    this.info = res.data.data;
                }
            })
        },
        downloadFile(item){
            downloadFile(item.fileUrl, item.fileName)
        },
        handleFIleStatus(status){
            if (status !== 1) {
                this.$message.info("文件正在处理，请稍后刷新预览")
            }
        },
        gainFileImgList(baseUrl,page,){
            const list = [];
            for (let i = 1; i <=page ; i++) {
                list.push(baseUrl+'/' + i+'.png');
            }
            return list;
        },
        jumpPageNotAuth(path){
            this.$router.push(path);
        },
        viewActivityInfo(){
            let link = this.serviceUrl+"/jzedu/event?aid="+this.infoId;
            window.open(link, '_blank')
        },
        getPageRaceSign(e){
            this.dataList = []
            if (e) {
                this.queryParams.pageNum = e.page;
                this.queryParams.pageSize = e.limit;
            }
            pageActivitySign(this.queryParams).then(res => {
                if (res.data.code === 1) {
                    this.dataList = res.data.data.list;
                    this.total = res.data.data.total;
                }else{
                    this.$message.error("请求出错")
                }
            })
        },
        queryUserSignInfo(row){
            infoActivitySignUp({ activityId: this.infoId,username: row.userId }).then(res => {
                if (res.data.code === 1) {
                    this.signInfo = res.data.data;
                    this.signForm = this.signInfo;
                    this.signForm.username = this.signInfo.userId;
                    queryDict({code: 'archive_xd_xk'}).then(res => {
                        this.periodList = res.data.data;
                        this.subjectList = [];
                        this.periodList.forEach(j => {
                            if (this.signForm.periodKey === j.dictKey) {
                                this.subjectList = j.childrenList;
                            }
                        })
                    })
                    this.showMode = 'info';
                }else {
                    this.$message.error("当前手机号码暂未提交资料")
                }
            });
        },
        openVideo(url){
            this.videoSrc = url;
            this.isShowVideo = true;
        },
        closeIframe() {
            const iframe = document.getElementById("open-video"); // 获取到要关闭的iframe元素
            iframe.setAttribute("src", '');
            if (typeof iframe !== "undefined" && iframe !== null) {
                var contentWindow = iframe.contentWindow; // 获取到iframe内部的window对象
                if (typeof contentWindow !== "undefined" && contentWindow != null) {
                    contentWindow.close(); // 调用close()方法关闭iframe
                } else {
                    console.log("无效的iframe或者未加载完成！");
                }
            } else {
                console.log("没有找到指定的iframe元素！");
            }
        },
        backPage(){
            this.showMode = 'page';
        },
    }
}
</script>
<style>
.home-entry-container{
    width: 100vw;
    height: 100vh;
    margin: 0;
    overflow-y: auto!important;
    overflow-x: hidden;

}
.entry-head-container{
    width: 100%;
    height: 90px;
    display: flex;
    background-color: #ff7f2e;
}
.entry-top-left1{
    width: 110px;
    height: 100%;
    padding-left: 10px;
    box-sizing: border-box;
}
.entry-wel-logo{
    width: 100%;
    height: 90px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #e7eef6;
    font-size: 20px;
    img {
        width: 70px;
    }
}
.entry-top-left2{
    width: calc(100% - 230px);
    height: 100%;
}
.entry-top-left21{
    height: 50px;
    width: 100%;
    color: #fff;
    line-height: 60px;
    text-indent: 30px;
    font-size: 20px;
    font-weight: bold;
    display: flex;
}
.entry-status-info-bm{
    width: auto;
    height: 20px;
    line-height: 18px;
    border-radius: 8px;
    background-color: #4095e5;
    font-size: 12px;
    text-align: center;
    color: #fff;
    margin-top: 23px;
    text-indent: 0!important;
    padding: 0 6px 0 6px;
}
.entry-top-left22{
    height: 40px;
    width: 100%;
    color: #fff;
    text-indent: 30px;
    font-size: 15px;
    font-weight: bold;
}
.entry-top-right{
    width: 120px;
    height: 100%;
}
.entry-content-container{
    width: 1200px;
    height: calc(100vh - 90px);
    padding-top: 10px;
    box-sizing: border-box;
    margin: auto;
}
.entry-content-container2{
    width: 1000px;
    height: calc(100vh - 90px);
    padding-top: 10px;
    box-sizing: border-box;
    margin: auto;
}
.event-topic-sign-container{
    width: 100%;
    height: auto;
    padding-left: 20px;
    padding-bottom: 20px;
    padding-top: 10px;
    box-sizing: border-box;
}
.event-topic-sign-title{
    display: flex;
    width: 100%;
    height: 40px;
    line-height: 40px;
    font-size: 16px;
    font-weight: bold;
    color: #ff7f2e;
    margin-bottom: 5px;
    margin-top: 5px;
}
.event-topic-sign-form{
    width: 100%;
    height: auto;
}
.entry-file-list{
    width: 100%;
    height: auto;
}
.entry-file-item{
    display: flex;
    height: 30px;
    width: 100%;
    padding-left: 10px;
    padding-right: 10px;
    box-sizing: border-box;
}
.entry-file-item:hover{
    color: #ff7f2e!important;
    font-weight: bold;
}
.entry-file-title{
    width: calc(100% - 60px);
    height: 100%;
    font-size: 15px;
    line-height: 30px;
    cursor: pointer;
    color: #ff7f2e;
}
.entry-file-view{
    width: 32px;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    svg{
        cursor: pointer;
    }
}
.entry-file-download{
    width: 30px;
    height: 100%;
}
.entry-file-icon{
    width: 22px;
    height: 22px;
    cursor: pointer;
}
.kl-container{
    width: 100%;
    height: 40px;
    display: flex;
}
.kl-l{
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.kl-r{
    width: calc(100% - 80px);
    height: 40px;
    line-height: 40px;
    font-size: 16px;
    font-weight: bold;
    color: #ff7f2e;
    text-align: center;
}
</style>